import miniToastr from 'mini-toastr'
window._ = require('lodash');

miniToastr.init()
miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
miniToastr.setIcon('error', 'i', {'class': 'fa fa-times'})

try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
} catch (e) {}

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(undefined, error => {
  if (error.response.status !== 422) {
    miniToastr.error('Something went wrong', 'Server Error!')
  }
  return Promise.reject(error);
});

let token = document.head.querySelector('meta[name="csrf-token"]').content;

window.token = token;
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

require('lity')

window.notification = miniToastr



// WEBPACK FOOTER //
// ./resources/js/bootstrap.js